module.exports = __webpack_public_path__ + "static/media/loading.aaba0c03.svg";